/* eslint-disable react-hooks/exhaustive-deps */
import { faCirclePlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FieldArray, FormikProps, getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";

import {
  NotifiedCountriesCode,
  NotifiedCountriesTimePeriod
} from "../../../../config/filingConstants";
import { IOtherIncomes } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import FASvgIcon from "../../../FASvgIcon";
import PreventEditComponent from "../../../PreventEditComponent";
import PriceDisplay from "../../../PriceDisplay";
import { NumericInputField, SelectInputField } from "../../../fields";

const OIAnyIncomeSection89AForm = () => {
  const { values } = useFormikContext<IOtherIncomes>();

  const [sum, setSum] = useState(0);
  const [inputTotal, setInputTotal] = useState<{ [key: string]: number }>({});
  const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

  useEffect(() => {
    let _sum = 0;
    let _totalInput: { [key: string]: number } = {};
    if (values?.UnderSection89AIncomes?.length) {
      values?.UnderSection89AIncomes.forEach((item, index) => {
        _totalInput[index] = parseInt(item[1]) || 0;
        if (item.length && item[1]) {
          _sum += parseInt(item[1]) || 0;
        }
      });
      setInputTotal(() => _totalInput);
    }
    setSum(() => _sum);
  }, [currentTime]);

  const handleAmountInc = (amt: number, index: string) => {
    inputTotal[index] = amt;
    setInputTotal(() => inputTotal);
    const _sum = Object.values(inputTotal).reduce((a, b) => Number(a) + Number(b), 0);
    setSum(() => _sum);
  };

  return (
    <section className="mb-5">
      <div className="section-title-wrap">
        <h5>Income under section 89A</h5>
      </div>
      <Card className="more-info-card shadow-none">
        <Card.Header>
          <Card.Title>
            Income from retirement benefits account maintained in a notified country
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <section>
            <FieldArray name="UnderSection89AIncomes">
              {({ push, replace, remove, form }) => (
                <>
                  {values?.UnderSection89AIncomes && values?.UnderSection89AIncomes?.length > 0
                    ? values?.UnderSection89AIncomes.map((_, index) => (
                        <section className="mb-3 mb-sm-0" key={`section-89-a-${index}`}>
                          <Section89AForm
                            index={index}
                            form={form}
                            onRemove={(itemIdx: number) => {
                              if (values.UnderSection89AIncomes.length === 1) {
                                replace(itemIdx, ["", "", ""]);
                              } else {
                                remove(itemIdx);
                              }

                              setCurrentTime(new Date().getTime());
                            }}
                            handleAmountInc={handleAmountInc}
                          />
                        </section>
                      ))
                    : null}
                  <PreventEditComponent>
                    <Button
                      variant="link"
                      className="btn-add-link"
                      onClick={() => push(["", "", ""])}
                    >
                      <FASvgIcon icon={faCirclePlus} />
                      Add more
                    </Button>
                  </PreventEditComponent>
                </>
              )}
            </FieldArray>
          </section>
        </Card.Body>
        <Card.Footer>
          <p className="total-content">
            <span className="total-label">Total:</span>
            <span className="total-amount">
              <PriceDisplay price={sum} />
            </span>
          </p>
        </Card.Footer>
      </Card>
    </section>
  );
};

export default OIAnyIncomeSection89AForm;

type S89AFormProps = {
  index: number;
  form: FormikProps<IOtherIncomes>;
  onRemove: (itemIdx: number) => void;
  handleAmountInc: (amt: number, index: string) => void;
};

const Section89AForm: React.FC<S89AFormProps> = (props: S89AFormProps) => {
  const { index, onRemove, form, handleAmountInc } = props;

  const { setFieldValue, handleBlur, values, touched, errors } = form;

  return (
    <>
      <Row className="align-items-center">
        <Col sm={4}>
          <SelectInputField
            placeholder="Select other"
            name={`UnderSection89AIncomes.${index}.[0]`}
            label="Country"
            isClearable={false}
            options={UtilService.convertToArray(NotifiedCountriesCode)}
            value={{
              "label": NotifiedCountriesCode[values.UnderSection89AIncomes[index][0]],
              "value": values.UnderSection89AIncomes[index][0]
            }}
            onChange={(selectedStatus) => {
              if (selectedStatus) {
                setFieldValue(`UnderSection89AIncomes.${index}.[0]`, selectedStatus.value);
              } else {
                setFieldValue(`UnderSection89AIncomes.${index}.[0]`, undefined);
              }
            }}
            onBlur={handleBlur(`UnderSection89AIncomes.${index}.[0]`)}
            isInvalid={
              Boolean(getIn(errors, `UnderSection89AIncomes.${index}.[0]`)) &&
              getIn(touched, `UnderSection89AIncomes.${index}.[0]`)
            }
            errorMsg={getIn(errors, `UnderSection89AIncomes.${index}.[0]`)}
          />
        </Col>
        <Col sm={4}>
          <SelectInputField
            placeholder="Select other"
            name={`UnderSection89AIncomes.${index}.[2]`}
            label="Time Period"
            isClearable={false}
            isOptionArrayOfObject={false}
            options={NotifiedCountriesTimePeriod}
            value={[values.UnderSection89AIncomes[index]?.[2]]}
            onChange={(selectedStatus) => {
              if (selectedStatus) {
                setFieldValue(`UnderSection89AIncomes.${index}.[2]`, selectedStatus.value);
              } else {
                setFieldValue(`UnderSection89AIncomes.${index}.[2]`, undefined);
              }
            }}
            onBlur={handleBlur(`UnderSection89AIncomes.${index}.[2]`)}
            isInvalid={
              Boolean(getIn(errors, `UnderSection89AIncomes.${index}.[2]`)) &&
              getIn(touched, `UnderSection89AIncomes.${index}.[2]`)
            }
            errorMsg={getIn(errors, `UnderSection89AIncomes.${index}.[2]`)}
          />
        </Col>
        <Col sm>
          <NumericInputField
            showLeftIcon={true}
            placeholder=""
            name={`UnderSection89AIncomes.${index}.[1]`}
            label="Amount"
            value={values.UnderSection89AIncomes[index]?.[1]}
            onBlur={handleBlur(`UnderSection89AIncomes.${index}.[1]`)}
            onChange={(value) => {
              setFieldValue(`UnderSection89AIncomes.${index}.[1]`, value);
              setTimeout(() => {
                handleAmountInc(Number(value), String(index));
              }, 100);
            }}
            isInvalid={
              Boolean(getIn(errors, `UnderSection89AIncomes.${index}.[1]`)) &&
              getIn(touched, `UnderSection89AIncomes.${index}.[1]`)
            }
            errorMsg={getIn(errors, `UnderSection89AIncomes.${index}.[1]`)}
          />
        </Col>
        <PreventEditComponent>
          <Col sm={"auto"} className="ps-0">
            <Button
              variant="transparent"
              className="text-greyDark icon-only d-none d-sm-flex"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
            </Button>
            <Button
              variant="transparent"
              className="btn-delete-full d-sm-none"
              onClick={() => onRemove(index)}
            >
              <FASvgIcon icon={faTrash} />
              <span>Delete</span>
            </Button>
          </Col>
        </PreventEditComponent>
      </Row>
      {index !== values.UnderSection89AIncomes.length - 1 && (
        <hr className="d-block d-sm-none my-4" />
      )}
    </>
  );
};
